module.exports = __webpack_public_path__ + "img/leighton_b2.fa807d28.jpg";